import React, { useEffect, useState } from 'react';
import {
  formatDateToShortDotV2,
  getRemainingTime,
  BaseButton,
  useAuth,
  useLoginRequiredModal,
  useT,
} from '@repo/common';
import ApplyNowModal from '../../Apply/ApplyNowModal';

const DetailSidebarApply = ({ job, hasApplied, onApplied }) => {
  const t = useT();
  const { isLoggedIn } = useAuth();
  const { showLoginModal } = useLoginRequiredModal();
  const { applicationDeadline, hiringStatus } = job;
  const isOngoing = hiringStatus === 'ONGOING_HIRING';
  const [remainingTime, setRemainingTime] = useState('');
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);

  useEffect(() => {
    if (isOngoing || !applicationDeadline) return;

    const update = () => {
      setRemainingTime(getRemainingTime(applicationDeadline));
    };

    update();
    const timer = setInterval(update, 1000);

    return () => clearInterval(timer);
  }, [applicationDeadline, isOngoing]);

  const handleApplyClick = () => {
    if (!isLoggedIn) {
      showLoginModal('jobboard_detail_apply_cta');
      return;
    }
    if (!isClosed && !hasApplied) setIsApplyModalOpen(true);
  };

  // ongoing이 false이거나 마감일이 지난 경우 closed 처리
  const deadlinePassed =
    !!applicationDeadline && new Date(applicationDeadline) < new Date();
  const isClosed = !isOngoing && (!applicationDeadline || deadlinePassed);

  return (
    <div className='flex flex-col items-start p-0 gap-6 w-full tabletV:max-w-[274px]'>
      <div className='flex flex-col gap-2'>
        <div className='flex flex-col items-center gap-0.5'>
          <div className='flex gap-1.5 typo-b12 text-text-placeholder'>
            {isOngoing ? (
              <>{t('Ongoing hiring', '상시 채용')}</>
            ) : (
              <>
                <div>{t('Apply by', '마감')}</div>
                <div>{formatDateToShortDotV2(applicationDeadline)}</div>
              </>
            )}
          </div>
          {!isOngoing && (
            <div className='typo-b18Strong text-text-accent'>
              {remainingTime}
            </div>
          )}
        </div>

        <BaseButton
          width='274px'
          size='l'
          hideIcon
          bgclass='shadow-2'
          onClick={handleApplyClick}
          isDisabled={hasApplied || isClosed}
        >
          {hasApplied ? t('Applied', '지원 완료') : t('Apply now', '지원하기')}
        </BaseButton>

        {isApplyModalOpen && (
          <ApplyNowModal
            job={job}
            isOpen={isApplyModalOpen}
            onClose={() => setIsApplyModalOpen(false)}
            onSuccess={onApplied}
          />
        )}
      </div>
    </div>
  );
};

export default DetailSidebarApply;
